<template>
  <layout
    v-if="token.length <= 0"
    key="login-page"
  >
    <template slot="authentication-content">
      <b-container fluid>
        <b-modal
          id="modalInfo"
          v-model="modalState"
          hide-footer
        >
          <p class="intro">
            {{ $helper.isLegacy ? $t('legacy.oauth.login.intro') : $t('oauth.login.intro') }}
          </p>
          <!-- eslint-disable vue/no-v-html -->
          <p
            v-if="hasText"
            class="text"
            v-html="$t($helper.isLegacy ? 'legacy.oauth.login.text_first_connexion' : 'oauth.login.text_first_connexion')"
          />
          <p
            class="text"
            v-html="modalText"
          />
          <!-- eslint-enable vue/no-v-html -->
        </b-modal>
        <b-row
          class="no-gutters"
          align-v="center"
        >
          <b-col lg="6">
            <b-card>
              <h1>{{ $helper.isLegacy ? $t('legacy.title') : companyName }}</h1>
              <p class="intro">
                {{ textIntro }}
              </p>
              <p class="text">
                {{ textPresentation }}
              </p>
              <b-btn
                class="know-more-link"
                variant="link"
                @click="openInfoModal"
              >
                {{ $t('actions.know_more') }}
              </b-btn>
              <social-networks />
            </b-card>
          </b-col>
          <b-col lg="6">
            <b-card class="login-form">
              <h2>{{ $t('oauth.login.title') }}</h2>
              <form v-loading="`<i class='ti ti-refresh ti-spin'></i>`" @submit.prevent="submit">
                <vue-form-generator
                  :schema="schema"
                  :model="model"
                  :options="{ validationAfterLoad: true, validationAfterChanged: true }"
                />
                <b-button
                  variant="link"
                  :to="{ name: 'request' }"
                >
                  {{ $t('oauth.login.forgotten_password') }}
                </b-button>
                <b-button
                  v-if="schema.fields.length > 0"
                  type="submit"
                  variant="primary"
                  class="btn-fixed-bottom text-uppercase"
                  block
                >
                  {{ $t('actions.login') }}
                </b-button>
              </form>
            </b-card>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </layout>
  <div
    v-else
    key="auto-login-page"
  >
    <div class="reconnect">
      <loading-text :title="$t('auth.relogin')" />
    </div>
  </div>
</template>

<script>
  import SocialNetworks from '@/components/social-networks';
  import VueFormGenerator from '@triotech/vue-core/src/vendor/vue-form-generator';
  import Layout from '@/views/Authentication/layout';
  import LoadOnNavigate from '@/mixins/load-on-navigate';
  import LoadingText from '@/components/loader-text';

  export default {
    name: 'LoginView',
    components: {
      'vue-form-generator': VueFormGenerator.component,
      Layout,
      SocialNetworks,
      LoadingText,
    },
    mixins: [
      LoadOnNavigate,
    ],
    props: {
      token: {
        type: String,
        default: '',
      },
      player: {
        type: String,
        default: '',
      },
      displayModal: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      const email = this.$helper.isLegacy
        ? this.$t('legacy.oauth.login.email')
        : this.$t('oauth.login.email');
      return {
        modalState: false,
        hasText: false,
        model: {},
        schema: {
          fields: [
            {
              default: '',
              disabled: false,
              featured: '',
              id: 'username',
              inputType: 'text',
              label: email,
              maxlength: null,
              model: 'username',
              placeholder: email,
              readonly: false,
              required: true,
              type: 'input',
              autocomplete: 'username',
            },
            {
              default: '',
              disabled: false,
              featured: '',
              hint: '',
              id: 'password',
              inputType: 'password',
              label: this.$t('oauth.login.password'),
              maxlength: null,
              min: 4,
              minlength: 4,
              model: 'password',
              placeholder: this.$t('oauth.login.password'),
              readonly: false,
              required: true,
              type: 'input',
              autocomplete: 'current-password',
            },
          ],
        },
      };
    },
    computed: {
      companyName() {
        if (this.get().parameters && this.get().parameters.company) {
          return this.get().parameters.company.value;
        }

        return null;
      },
      modalText() {
        return this.$helper.isLegacy ? this.$t('legacy.oauth.login.text', { company: 'MonPCIE' }) : this.$t('oauth.login.text', { company: this.companyName });
      },
      tokenModel() {
        return {
          token: this.token,
          player: this.player,
        };
      },
      textIntro() {
        return this.$helper.isLegacy ? this.$t('legacy.oauth.login.presentation.intro') : this.$t('oauth.login.presentation.intro', { company: this.companyName });
      },
      textPresentation() {
        return this.$helper.isLegacy ? this.$t('legacy.oauth.login.presentation.text') : this.$t('oauth.login.presentation.text');
      },
    },
    mounted() {
      // User without Token => dashboard.
      if (this.user() && !this.token) {
        this.forwardToDashboard();
      }

      // Token without User => login => career
      if (this.token && !this.user()) {
        this.loggingWithToken();
      }

      // Token and User => career
      if (this.token && this.user()) {
        this.forwardToCareer();
      }
      let currentUrl = window.location.host;

      localStorage.clear();
      if(currentUrl.search('monpcie.fr') >= 0)
      {
        window.location.href = "https://my.icdl.quebec";
      }


      // No Token and No User, wait form submit.
    },
    methods: {
      load() {
        this.modalState = this.displayModal;
        this.hasText = true;
      },
      openInfoModal() {
        this.modalState = true;
        this.hasText = false;
      },
      loggingWithToken() {
        this.$ajax.loggingByToken(this.tokenModel).then(() => {
          this.$helper.setLocale(this.user() ? (this.user().preferred_locale ? this.user().preferred_locale : window.navigator.language) : window.navigator.language);
          this.$nextTick(this.forwardToCareer);
        });
      },
      submit() {

        return this.$ajax.login(this.model).then(() => {

          this.$nextTick(this.forwardToDashboard);
          this.$helper.setLocale(this.user().preferred_locale);

        }).catch((err) => {
          if (err.response && err.response.data) {
            this.$notify({
              title: this.$t('flashes.login.title'),
              text: this.$t(`flashes.login.${err.response.data.error}`),
              type: 'error',
            });
          }
        });
      },
      forwardToDashboard() {
        this.$router.push({ name: 'dashboard' });
      },
      forwardToCareer() {
        if (this.player === this.get().enums.player.eval) {
          this.$router.push({ name: 'evaluation', params: { setHistory: true } });
        } else if (this.player === this.get().enums.player.certif) {
          this.$router.push({ name: 'certification', params: { setHistory: true } });
        } else if (this.player === this.get().enums.player.prepa) {
            this.$router.push({ name: 'preparation', params: { setHistory: true } });
        } else {
          this.$router.push({ name: 'dashboard' });
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';

  h1,
  h2 {
    border-bottom: 2px solid;
    padding-bottom: 1rem;
  }

  h1 {
    border-bottom-color: $light-grey;
  }

  h2 {
    border-bottom-color: $primary;
  }

  .intro {
    margin: 2rem 0;
    color: $secondary;
  }

  .know-more-link {
    padding: 0;
    font-size: 0.8rem;
    margin-bottom: 1rem;
  }

  .text {
    color: $grey;
    font-size: 0.8rem;
  }

  .login-form {
    position: relative;
    padding-bottom: 30px;

    .btn-fixed-bottom {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
    }
  }
</style>
